export enum ChipTypes {
  Beta = 'Beta',
  LandingPage = 'Landing Page',
  Popup = 'Popup',
  StickyBar = 'Sticky Bar',
  Administrator = 'Administrator',
  Author = 'Author',
  Owner = 'Owner',
  Viewer = 'Viewer',
  Pending = 'Pending'
}

export enum ChipColors {
  GullGray_DEPRECATED = 'gullGray_DEPRECATED',
  KleinBlue = 'kleinBlue',
  LinkWater = 'linkWater',
  UnbounceBlue = 'unbounceBlue',
  Shamrock = 'shamrock',
  Orange = 'orange'
}
